import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface IMacBotState {
  parentId: string | null;
  data: any;
  isShowElseForm: boolean;
  isShowResponseForm: boolean;
  isShowUserInputForm: boolean;
  isShowGotoForm: boolean;
  isShowButtonForm: boolean;
  isShowLinkForm: boolean;
  isShowVariableForm: boolean;
  isShowHTTPRequestForm: boolean;
  isShowMakeWebHookForm: boolean;
  isShowConditionForm: boolean;
  isShowOverrideVariableForm: boolean;
  isShowCreateVariableForm: boolean;
  isShowLeadForm: boolean;
  isShowMediaForm: boolean;
  isShowAttachmentForm: boolean;
  isShowDelayForm: boolean;
  isShowEndOfConversationForm: boolean;
  isShowFrom: boolean;
  isShowNotifyMeByEmailForm: boolean;
  isShowReceiveAttachmentForm: boolean;
  isShowSuperUserManagerServices: boolean;
  isShowCheckIfUserExists: boolean;
  isShowUserCredential: boolean;
  isShowGetUserInfo: boolean;
  isShowRegisterUser: boolean;
  isShowPassToAi: boolean;
  isShowSwitchToChatbot: boolean;
  isShowSpeechRecording: boolean;
  isShowAskToAI: boolean;
  isShowJSCode: boolean;
  isShowSummarizeConversation: boolean;
  isShowMessages?: boolean;
}

interface MacBotPayload {
  data: any;
  parentId?: string | null;
}

const initialState: IMacBotState = {
  parentId: null,
  data: null,
  isShowElseForm: false,
  isShowResponseForm: false,
  isShowUserInputForm: false,
  isShowGotoForm: false,
  isShowButtonForm: false,
  isShowLinkForm: false,
  isShowVariableForm: false,
  isShowHTTPRequestForm: false,
  isShowMakeWebHookForm: false,
  isShowConditionForm: false,
  isShowOverrideVariableForm: false,
  isShowCreateVariableForm: false,
  isShowLeadForm: false,
  isShowMediaForm: false,
  isShowAttachmentForm: false,
  isShowDelayForm: false,
  isShowEndOfConversationForm: false,
  isShowFrom: false,
  isShowNotifyMeByEmailForm: false,
  isShowReceiveAttachmentForm: false,
  isShowSuperUserManagerServices: false,
  isShowCheckIfUserExists: false,
  isShowUserCredential: false,
  isShowGetUserInfo: false,
  isShowRegisterUser: false,
  isShowPassToAi: false,
  isShowSwitchToChatbot: false,
  isShowSpeechRecording: false,
  isShowAskToAI: false,
  isShowJSCode: false,
  isShowSummarizeConversation: false,
  isShowMessages: false,
};

const macBotSlice = createSlice({
  name: 'macBot',
  initialState,
  reducers: {
    showForm: (state, action: PayloadAction<{ key: keyof IMacBotState; payload: MacBotPayload }>) => {
      // Reset all flags first
      Object.keys(state).forEach(k => {
        if (k.startsWith('isShow')) {
          (state as any)[k] = false;
        }
      });

      const { key, payload } = action.payload;
      state[key] = true as any; // set the specific form flag
      state.data = payload.data;
      state.parentId = payload.parentId ?? null;
    },
    closeForm: (state, action: PayloadAction<{ parentId?: string | null } | undefined>) => {
      Object.keys(state).forEach(k => {
        if (k.startsWith('isShow')) {
          (state as any)[k] = false;
        }
      });
      state.data = null;
      state.parentId = action?.payload?.parentId ?? null;
    },
  },
});

export const { showForm, closeForm } = macBotSlice.actions;
export default macBotSlice.reducer;
